import {
  createSignal,
  For,
  Index,
  onMount,
  Show,
} from "solid-js";
import { Motion, Presence } from "@motionone/solid";
import { spring, stagger } from "motion";

export const AlsoAvailableDropdowns = () => {
  let alsoAvailableInContainer;
  const [openIndex, setOpenIndex] = createSignal(-1);

  const handleAccordian = (index) => {
    if (index != openIndex()) {
      setOpenIndex(index);
    } else {
      setOpenIndex(-1);
    }
  };


  return (
    <Show when={Object.keys(relatedProducts).length > 0}>
      <div
        ref={alsoAvailableInContainer}
        class="px-4 sm:px-6 pb-1 mt-2 font-bold text-lg"
      >
        Also available in
      </div>
      <div class="border-frame">
        <Index each={Object.values(relatedProducts)}>
          {(relatedProduct, index) => {
            return (
              <AlsoAvailableFabricGroup
                handleAccordian={handleAccordian}
                index={index}
                openIndex={openIndex}
                product={relatedProduct}
              />
            );
          }}
        </Index>
      </div>
    </Show>
  );
};

const AlsoAvailableFabricGroup = ({
  handleAccordian,
  index,
  openIndex,
  product,
}) => {
  return (
    <div>
      <AlsoAvailbleFabricHeader
        handleAccordian={handleAccordian}
        index={index}
        openIndex={openIndex}
        product={product}
      />
      <Presence>
        <Show when={index === openIndex()}>
          <Motion.div
            style={{ originY: -1 }}
            initial={{ opacity: 0, y: -10, }}
            animate={{ opacity: 1, y: 0,  }}
            exit={{ opacity: 0, y: -10, }}
            transition={{ duration: 0.3 }}
          >
            <AlsoAvailbleFabricList product={product} />
          </Motion.div>
        </Show>
      </Presence>
    </div>
  );
};

const AlsoAvailbleFabricHeader = ({
  handleAccordian,
  index,
  openIndex,
  product,
}) => {
  return (
    <div
      onClick={() => {
        handleAccordian(index);
      }}
      classList={{
        "bg-canvas-light": !(index === openIndex()),
        "bg-canvas-lighter": (index === openIndex()),
      }}
      class="flex justify-between py-2 px-4 sm:px-6 items-center  border-t-outer border-frame  cursor-pointer hover:bg-canvas-lighter"
    >
      <div class="font-bold">{product().fabricType}</div>
      <div class="flex items-center gap-1">
        <div class="flex">
          <Index each={Object.entries(product().swatchImgUrl)}>
            {(swatch, i) => {
              if (i < 3) {
                const [swatchName, swatchURL] = swatch();
                return (
                  <img
                    alt={swatchName}
                    class="w-3 h-3 sm:w-4 sm:h-4 rounded-full border-outer border-frame bg-canvas-light -mr-1 last:mr-0 lazyload"
                    src={`${swatchURL}&width=24`}
                    data-srcset={[34, 49, 58, 68, 102, 116, 174]
                      .map((width) => `${swatchURL}&width=${width} ${width}w`)
                      .join(", ")}
                  />
                );
              }
            }}
          </Index>
        </div>
        <Show when={Object.keys(product().swatchImgUrl).length > 3}>
          <span class="">
            {" "}
            + {Object.keys(product().swatchImgUrl).length - 3}
          </span>
        </Show>

        <svg
          width="16"
          viewBox="0 0 32 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="transition-transform"
          classList={{
            "-rotate-90": !(index === openIndex()),
          }}
        >
          <path
            d="M6 0L2.52947e-08 6.37339L16 23.3691L32 6.37339L26 0L16 10.6223L6 0Z"
            fill="currentColor"
          />
        </svg>
      </div>
    </div>
  );
};

export const AlsoAvailbleFabricList = ({ product }) => {
  let fabricContainer;
  const colors = product()["colors"];

  onMount(() => {
    const fabricScroller = new HorizontalScroller({
      scrollContainer: fabricContainer,
      wrapperClass: "fabric-scroll-wrapper",
      slideClass: "variant-slide",
      scrollMultiplier:0.8
    });
  });

  const mockColorGroup = colors.map((color) => {
    const colorHandleized = handleize(color);
    const src = product()["featuredImgUrl"][colorHandleized];
    const srcSet = [
      16, 32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448,
      480, 512, 720, 1449,
    ]
      .map((width) => `${src}&width=${width} ${width}w`)
      .join(", ");

    return {
      color: color,
      thumbnailSrc: {
        src: `${src}&width=8`,
        srcSet: srcSet,
      },
      href: `${
        window.location.protocol + "//" + window.location.host
      }/products/${product()["handle"]}?color=${colorHandleized}`,
    };
  });

  return (
    <div
      ref={fabricContainer}
      class="font-regular text-sm sm:text-base border-b-outer last:border-b-0 border-frame relative  "
    >
      <div class="flex overflow-x-scroll p-2 md:p-4 gap-2 snap-x snap-mandatory fabric-scroll-wrapper scroll-smooth shadow-inner bg-canvas-depressed themed-scrollbar scroll-pl-4 md:scroll-pl-6">
        <Index each={mockColorGroup}>
          {(colorObj, index) => {
            const { href, color, thumbnailSrc } = colorObj();
            const src = thumbnailSrc["src"];
            const srcSet = thumbnailSrc["srcSet"];
            return (
                
            <Motion.div class="self-stretch flex"
            initial={{ opacity: 0, x: -10, }}
            animate={{ opacity: 1, x: 0,  }}
            exit={{ opacity: 0, x: -10, }}
            transition={{ duration: 0.5 }}
            delay={stagger(index*0.1)}
            easing={spring()}

              >
                <a
                  href={`${href != undefined ? href : "#"}`}
                  class="variant-slide flex flex-col items-center w-12 xl:w-24 border-solid border-frame gap-1 snap-start hover:-translate-y-0.5 transition-transform"
                >
                  <img
                    src={`${src}&width=96`}
                    data-srcset={srcSet}
                    width="auto"
                    height="auto"
                    data-sizes="auto"
                    class="lazyautosizes lazyload w-full object-cover text-transparent aspect-[4/5] rounded-2xl bg-secondary-400"
                    alt={color}
                    loading="lazy"
                  />
                  <div class="mx-1 text-ink font-medium flex-grow text-xs">{color}</div>
                </a>
              </Motion.div>
            );
          }}
        </Index>
      </div>
    </div>
  );
};
